import React, {Fragment} from "react";

import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import {FormInput, FormInputPassword} from "root/ReactHookForm/FormComponents";
import {getVariant, VariantString} from "root/textVariants";
const FormFragmentLoginInputs = ({ authority_id, iconColor, register, rules = [], sectionName, formErrors, showLabels= false, showUsernameInput=false, showProviderInput=false, showExistingPasswordInput=false, showPasswordInput=false, showConfirmPassword=false }) =>
{
    const establishment_label = getVariant( authority_id, VariantString.ESTABLISHMENT_LABEL ) ;

    return (
        <Fragment>
            { showProviderInput === true && <BootstrapCol width={12} style={{marginBottom: '10px'}}>
                <FormInput autofocus readOnly={false} label={establishment_label} placeHolder={establishment_label}
                           sectionName={sectionName} name={'establishment_number'} register={register} required={false} maxLength={30}
                           formErrors={formErrors}/>
            </BootstrapCol> }

            { showUsernameInput === true && <BootstrapCol width={12} style={{marginBottom: '10px'}}>
                <FormInput readOnly={false} label='Username' placeHolder='Username'
                           sectionName={sectionName} name={'username'} register={register} required={true} maxLength={150}
                           formErrors={formErrors}/>
            </BootstrapCol> }

            { showExistingPasswordInput === true && <BootstrapCol width={12} style={{marginBottom: '10px'}}>
                { showLabels === true && <label className='form-label'>Enter Existing Password</label> }
                <FormInputPassword iconColor={iconColor} readOnly={false} label='Existing Password' placeHolder='Existing Password'
                                   sectionName={sectionName} name={'oldpassword'} register={register} required={true} maxLength={100} autocomplete='off'
                                   formErrors={formErrors}/>
            </BootstrapCol> }

            { showPasswordInput === true && <BootstrapCol width={12} style={{marginBottom: '10px'}}>
                { showLabels === true && <label className='form-label'>Password</label> }
                <FormInputPassword iconColor={iconColor} readOnly={false} label='Surname' placeHolder='Password' rules={rules}
                                   sectionName={sectionName} name={'password'} register={register} required={true} maxLength={100} autocomplete='off'
                                   formErrors={formErrors}/>
            </BootstrapCol> }

            { showConfirmPassword === true &&<BootstrapCol width={12} style={{marginBottom: '20px'}}>
                { showLabels === true && <label className='form-label'>Confirm Password</label> }
                <FormInputPassword iconColor={iconColor} readOnly={false} placeHolder='Confirm Password'
                                   sectionName={sectionName} name={'password1'} register={register} required={true} maxLength={100}
                                   formErrors={formErrors}/>
            </BootstrapCol> }
        </Fragment>

    )
}

export default FormFragmentLoginInputs;